<template>
  <span :class="['badge', badgeClass]">
    {{ label }}
  </span>
</template>

<script>
export default {
  name: 'Badge',
  props: {
    value: {
      required: true
    },
    options: {
      type: Array,
      required: true
      /* Estrutura do array:
      [
        { value: 1, label: 'Alerta', class: 'badge-warning' },
        { value: 2, label: 'Pânico', class: 'badge-danger' },
        { value: 3, label: 'Emergência médica', class: 'badge-primary' }
      ]
      */
    }
  },
  computed: {
    currentOption() {
      return this.options.find(opt => opt.value === this.value) || {};
    },
    label() {
      return this.currentOption.label || 'Desconhecido';
    },
    badgeClass() {
      return this.currentOption.class || 'badge-secondary';
    }
  }
}
</script>